import { render } from "./ListPageTemplate.vue?vue&type=template&id=0d5bce54"
import script from "./ListPageTemplate.vue?vue&type=script&lang=js"
export * from "./ListPageTemplate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__